import React from "react";

export default class RelatedServices extends React.Component  
{
    constructor(props)    
    {
        super(props);        
        
        const code = this.props.code;
        const place = this.props.place !== undefined ? this.props.place.name : '';
        const place_name = place.replace(/ /g,'-').replace(/,/g,'').replace(/---/g,'-').toLowerCase();
        const place_type = this.props.place !== undefined ? this.props.place.ht : '';
        const current_build = this.props.env !== undefined ? this.props.env.build : '';

        this.place = place;

        this.services = [];

        const expresion_hub = /^Hub/g;
        const expresion_sub = /^Sub/g;

        if(place_type.match(expresion_hub) || place_type.match(expresion_sub))
        {
            if(current_build !== 'ppp10') this.services.push({
                'name': `10 Yard Dumpsters in ${this.place}`,
                'url': 'h/'+place_name+'/10-yard-dumpster',
                'code': 'static'
            });

            if(current_build !== 'ppp20') this.services.push({
                'name': `20 Yard Dumpsters in ${this.place}`,
                'url': 'h/'+place_name+'/20-yard-dumpster',
                'code': 'static'
            });

            if(current_build !== 'ppprolloff') this.services.push({
                'name': `30 Yard Dumpsters in ${this.place}`,
                'url': 'h/'+place_name+'/roll-off-dumpsters',
                'code': 'static'
            });

            if(current_build !== 'pppconstruction') this.services.push({
                'name': `Construction Dumpsters in ${this.place}`,
                'url': 'h/'+place_name+'/construction-dumpster',
                'code': 'static'
            });
        }
        
        this.props.services.forEach(service => {    
            const service_data =
            {
                name: `${service.title} in ${this.place}`,
                url: service.url
            }

            this.services.push(service_data);
        })

        this.ulclass = code !== undefined ? code : '';
    }

    render()
    {

        const reorderArray = (arr) => {
            const reordered = [];
            const midIndex = Math.ceil(arr.length / 2);
            
            for (let i = 0; i < midIndex; i++) {
                reordered.push(arr[i]);
                
                if (i + midIndex < arr.length) {
                    reordered.push(arr[i + midIndex]);
                }
            }
            
            return reordered;
        };

        return (
            <div className="related-services">
                <h2>Related Searches in {this.place}</h2>
                <article className="provider-card">
                    <div className={"items-list "+this.ulclass}>
                        {
                        reorderArray(this.services)?.map((service, index) => (
                            service && 
                            <a key={index} href={'/'+service.url} className="item">
                                <div className="item-text">                                    
                                    <h6>{service.name}</h6>
                                </div>
                            </a>
                        ))
                        }
                    </div>
                </article>
            </div>)
    }
};